// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8t-4";
export var collapsed = "_8t-1";
export var headerBar = "_8t-0";
export var leftHeaderContent = "_8t-3";
export var subjectContainer = "_8t-2";